import { Autocomplete, Box, Button, Checkbox, Dialog, FormControlLabel, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import axios from "axios";

import globalContext from '../context/context'
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AirportSearchField from "../utils/AirportSearchField";
import { useTranslation } from "react-i18next";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";

const getTodayEvening = () => {
    const now = new Date();
    const evening = new Date(now);
    evening.setHours(20, 0, 0, 0);
    if (evening < now) {
        evening.setDate(evening.getDate() + 1);
     }
    return evening.toISOString().replace('Z', '+00:00').substring(0, 16);
};

function SearchForm() {
    const { t } = useTranslation();
    const { contextData: { formValues, user, currency }, setFormValues, setResponseId, resetCart, setCurrency, setSnack, setMultipleFormValues } = useContext(globalContext);
    const [searchParams] = useSearchParams();
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchValue, setSearchValue] = useState(null);

    const [departureDialog, setDepartureDialog] = useState(false);
    const [arrivalDialog, setArrivalDialog] = useState(false);

    useEffect(() => {

        if (searchValue) {
            let active = true;

            (async () => {
                const response = await fetch(`/api/custom/airports?keyword=${searchValue}&t=${Date.now()}`);

                const airports = await response.json();

                if (active) {
                    // ABC sorrend szerint rendezés reptérkód alapján
                    const sortedAirports = (airports || []).sort((a, b) => {
                        if (!a.code || !b.code) return 0;
                        return a.code.localeCompare(b.code, 'hu', { sensitivity: 'base' });
                    });
                    setOptions(sortedAirports);
                }
            })();

            return () => {
                active = false;
            };
        }

    }, [searchValue]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const navigate = useNavigate();

    if (!formValues) {
        return null;
    }

    const submitForm = () => {

        if (
            !formValues.numberOfAdults
            || !formValues.destination_airport
            || !formValues.origin_airport

        ) {
            setSnack({
                message: t('searchForm.errorAirport'),
                severity: 'error',
                open: true
             })
            return;
         }

        if (
             new Date(formValues.departureSideStartDate ?? null) < new Date()
             || new Date(formValues.arrivalSideEndDate ?? null) < new Date()
             || formValues.arrivalSideEndDate < formValues.departureSideStartDate

         ) {
            setSnack({
                message: t('searchForm.errorDate'),
                severity: 'error',
                open: true
             })
            return;
         }

        if (
             !formValues?.singleTrip
             && (
                 !formValues.arrivalSideStartDate
                 || !formValues.departureSideEndDate
                 || new Date(formValues.arrivalSideStartDate ?? null) < new Date()
                 || new Date(formValues.departureSideEndDate ?? null) < new Date()
                 || formValues.arrivalSideStartDate > formValues.departureSideEndDate)
         ) {
            setSnack({
                message: t('searchForm.errorDate'),
                severity: 'error',
                open: true
             })
            return;
         }



        const bodyData = {
            departureSideStartDate: formValues.departureSideStartDate ? new Date(formValues.departureSideStartDate).toISOString() : null, // "2023-08-10T15:30:49.510Z",
            arrivalSideEndDate: formValues.arrivalSideEndDate ? new Date(formValues.arrivalSideEndDate).toISOString() : null, // "2023-08-21T15:30:49.510Z",
            arrivalSideStartDate: formValues.arrivalSideStartDate && !formValues?.singleTrip ? new Date(formValues.arrivalSideStartDate).toISOString() : null, // "2023-08-10T15:30:49.510Z",
            departureSideEndDate: formValues.departureSideEndDate && !formValues?.singleTrip ? new Date(formValues.departureSideEndDate).toISOString() : null, // "2023-08-21T15:30:49.510Z",
            departureFlightNumber: "NUM1",
            arrivalFlightNumber: "NUM2",
            singleTrip: formValues.singleTrip ?? false,
            numberOfAdults: formValues.numberOfAdults ?? 1, // 5,
            numberOfChildren: formValues.numberOfChildren ?? 0, // 5,
            numberOfInfants: formValues.numberOfInfants ?? 0, // 5,
            createdDate: new Date().toISOString(),
            languageCode: "EN",
            arrival: {
                code: formValues.destination_airport // BUD
            },
            departure: {
                code: formValues.origin_airport // MXP // MAN
            }
        };
        if (user?.id) {
            bodyData.customer = {
                id: user?.id
            };
        }

        if (searchParams?.get('partnerCode')) {
            bodyData.partnerCode = searchParams.get('partnerCode');
        }

        axios.post('/api/custom/searches', bodyData).then(r => {
            resetCart('withoutFormValues');
            if (r?.data) {
                setResponseId(r?.data);
                navigate('/parking')
            }
        }).catch(e => console.error('err', e))
    }

    const changeCheckBox = (e) => {
        const newSingleTrip = !formValues?.singleTrip;
        if (newSingleTrip) {
            setMultipleFormValues({
                singleTrip: true,
                arrivalSideStartDate: '',
                departureSideEndDate: ''
            });
        } else {
            setMultipleFormValues({
                singleTrip: false,
                arrivalSideStartDate: getTodayEvening(),
                departureSideEndDate: getTodayEvening()
            });
        }
     }

    return (
        <Box sx={{ py: 1, px: 3 }}>
            { /* <Select style={{ marginBottom: '20px' }} fullWidth onChange={(c) => setCurrency(c.target.value)} value={currency}>
                <MenuItem value="HUF">HUF</MenuItem>
                <MenuItem value="EUR">EUR</MenuItem>
                <MenuItem value="AED">AED</MenuItem>
    </Select> */ }


            <FormControlLabel control={<Checkbox
                checked={formValues.singleTrip}
                onChange={changeCheckBox}
            />} label={t('searchForm.singleTrip')} />

            <FormControlLabel control={<Checkbox
                checked={!formValues.singleTrip}
                onChange={changeCheckBox}
            />} label={t('searchForm.roundTrip')} />

            <AirportSearchField
                label={t('searchForm.originAirport')}
                value={formValues.origin_airport}
                onChange={setFormValues}
                fullWidth
                name="origin_airport"
            />
            <Button onClick={() => setDepartureDialog(true)} variant="outlined" sx={{ mt: 2 }} fullWidth>{t('searchForm.departureButton')} {formValues.departureSideStartDate && formValues.arrivalSideEndDate ? ` | ${new Date(formValues.departureSideStartDate).toLocaleString().slice(0, -3)} - ${new Date(formValues.arrivalSideEndDate).toLocaleString().slice(6, -3)}` : ''}</Button>

            <Dialog onClose={() => setDepartureDialog(false)} open={departureDialog}>
                <Box sx={{ p: 3, pb: 0 }}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                        {formValues.origin_airport}{` -> `}{formValues.destination_airport}
                    </Typography>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>

                    <Box sx={{ p: 3 }}>
                        { /* <TextField
                        sx={{ mt: 2 }}
                        name="departureSideStartDate"
                        variant="standard"
                        value={formValues.departureSideStartDate}
                        onChange={setFormValues}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        type="datetime-local"
            label={t('searchForm.departureStartDate')} /> */ }
                        <DateTimePicker
                            name="departureSideStartDate"
                            variant="standard"
                            label={t('searchForm.arrivalEndDate')}
                            value={formValues?.departureSideStartDate ? dayjs(formValues.departureSideStartDate) : dayjs()}
                            onChange={(e) => setFormValues(e, 'departureSideStartDate')}
                            ampm={false}
                            disablePast={true}
                            format="YYYY-MM-DD HH:mm"
                            sx={{ width: '100%' }}
                            views={['year', 'month', 'day', 'hours', 'minutes']}
                            slotProps={{
                                textField: {
                                    placeholder: t('searchForm.selectDeparture')
                                }
                            }}
                        />

                         <DateTimePicker
                            name="arrivalSideEndDate"
                            variant="standard"
                            label={t('searchForm.departureStartDate')}
                            value={formValues?.arrivalSideEndDate ? dayjs(formValues.arrivalSideEndDate) : dayjs()}
                            onChange={(e) => setFormValues(e, 'arrivalSideEndDate')}
                            ampm={false}
                            disablePast={true}
                            format="YYYY-MM-DD HH:mm"
                            sx={{ width: '100%', mt: 2 }}
                            views={['year', 'month', 'day', 'hours', 'minutes']}
                            slotProps={{
                                textField: {
                                    placeholder: t('searchForm.selectArrival')
                                }
                            }}
                        />
                         <Button onClick={() => setDepartureDialog(false)} variant="outlined" sx={{ mt: 2 }} fullWidth>OK</Button>
                    </Box>
                </LocalizationProvider>

            </Dialog>
            <Box sx={{ mt: 2 }}>
                <AirportSearchField
                    label={t('searchForm.destinationAirport')}
                    value={formValues.destination_airport}
                    onChange={setFormValues}
                    fullWidth
                    name="destination_airport"
                />

            </Box>
            {!formValues?.singleTrip &&
                <>
                    <Button onClick={() => setArrivalDialog(true)} variant="outlined" sx={{ mt: 2 }} fullWidth>{t('searchForm.arrivalButton')} {formValues.arrivalSideStartDate && formValues.departureSideEndDate ? ` | ${new Date(formValues.arrivalSideStartDate).toLocaleString().slice(0, -3)} - ${new Date(formValues.departureSideEndDate).toLocaleString().slice(6, -3)}` : ''}</Button>
                    <Dialog onClose={() => setArrivalDialog(false)} open={arrivalDialog}>
                        <Box sx={{ p: 3, pb: 0 }}>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                {formValues.destination_airport}{` -> `}{formValues.origin_airport}
                            </Typography>
                        </Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box sx={{ p: 3 }}>

                                  <DateTimePicker
                                     name="arrivalSideStartDate"
                                     variant="standard"
                                     label={t('searchForm.departureEndDate')}
                                     value={formValues?.arrivalSideStartDate ? dayjs(formValues.arrivalSideStartDate) : dayjs()}
                                     onChange={(e) => setFormValues(e, 'arrivalSideStartDate')}
                                    ampm={false}
                                    disablePast={true}
                                    format="YYYY-MM-DD HH:mm"
                                    sx={{ width: '100%', mt: 2 }}
                                    views={['year', 'month', 'day', 'hours', 'minutes']}
                                    slotProps={{
                                        textField: {
                                            placeholder: t('searchForm.selectDeparture')
                                        }
                                    }}
                                />

                                  <DateTimePicker
                                     name="departureSideEndDate"
                                     variant="standard"
                                     label={t('searchForm.arrivalStartDate')}
                                     value={formValues?.departureSideEndDate ? dayjs(formValues.departureSideEndDate) : dayjs()}
                                     onChange={(e) => setFormValues(e, 'departureSideEndDate')}
                                    ampm={false}
                                    disablePast={true}
                                    format="YYYY-MM-DD HH:mm"
                                    sx={{ width: '100%', mt: 2 }}
                                    views={['year', 'month', 'day', 'hours', 'minutes']}
                                    slotProps={{
                                        textField: {
                                            placeholder: t('searchForm.selectArrival')
                                        }
                                    }}
                                />
                                <Button onClick={() => setArrivalDialog(false)} variant="outlined" sx={{ mt: 2 }} fullWidth>OK</Button>

                            </Box>
                        </LocalizationProvider>
                    </Dialog>
                </>
            }

            <Grid spacing={2} container>
                <Grid item xs={4}>
                    <TextField
                        sx={{ mt: 2 }}
                        name="numberOfAdults"
                        value={formValues.numberOfAdults}
                        onChange={setFormValues}
                        variant="standard"
                        fullWidth
                        label={t('searchForm.adults')}
                        select
                        InputLabelProps={{ shrink: true }}
                        SelectProps={{ native: true }}
                    >
                        <option>0</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                    </TextField>
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        sx={{ mt: 2 }}
                        name="numberOfChildren"
                        value={formValues.numberOfChildren}
                        onChange={setFormValues}
                        variant="standard"
                        fullWidth
                        label={t('searchForm.children')}
                        select
                        InputLabelProps={{ shrink: true }}
                        SelectProps={{ native: true }}
                    >
                        <option>0</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                    </TextField>
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        sx={{ mt: 2 }}
                        name="numberOfInfants"
                        value={formValues.numberOfInfants}
                        onChange={setFormValues}
                        variant="standard"
                        fullWidth
                        label={t('searchForm.infants')}
                        select
                        InputLabelProps={{ shrink: true }}
                        SelectProps={{ native: true }}
                    >
                        <option>0</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                    </TextField>
                </Grid>
            </Grid>


            <Button onClick={() => submitForm()} variant="contained" sx={{ mt: 2 }} fullWidth>{t('searchForm.book')}</Button>

        </Box>
    );
}

export default SearchForm;
